/* eslint-disable max-lines-per-function */
/* eslint-disable react/forbid-elements */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable functional/no-conditional-statement */
/* eslint-disable functional/immutable-data */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/prefer-readonly-parameter-types */
import { FC, useEffect, useRef } from "react";
import { useOrderValueData } from "../../app/hooks/useOrderValueData";
import { useSetOrderState } from "../../app/hooks/useSetOrderState";
import { useSettingsValueData } from "../../app/hooks/useSettingsValueData";
import { parseCookie } from "../../payment/miscellaneous/parseCookie";
import { useState } from "../hooks/useState";
import { BreadCrumbsCurrencyOption } from "./BreadCrumbsCurrencyOption";
import { savePreferedCurrencyDetails } from "../miscellaneous/savePreferedCurrencyDetails";
import { useNavigate } from "../hooks/useNavigate";
import { useLocation } from "../hooks/useLocation";

export const BreadCrumbsCurrencyTab: FC = () => {
  const [showCurrencyDropdown, setShowCurrencyDropdown] =
    useState<boolean>(false);

  const [defaultCurrency, setDefaultCurrency] = useState<string>(
    parseCookie(document.cookie)["MkHcCurrencyId"] ?? "USD"
  );

  const navigate = useNavigate();
  const order = useOrderValueData();
  const setOrder = useSetOrderState();
  const settings = useSettingsValueData();
  const location = useLocation();
  const allowedCurrencies = settings.data?.allowedCurrencies;
  const prevLocationRef = useRef<string | null>(null);
  const isAllowCurrencyChange = settings.data.pageIntegration?.allowCurrencyChange;

  const loadPage = () => {
    disableButtonElements(false);
    navigate(`${prevLocationRef.current}`);
  };

  useEffect(() => {
    saveCurrency();
  }, []);

  useEffect(() => {}, [defaultCurrency]);

  useEffect(() => {
    prevLocationRef.current = location.pathname;
  }, [location]);

  const mouseEnterHandler = () => {
    setShowCurrencyDropdown(true);
  };

  const mouseLeaveHandler = () => {
    setShowCurrencyDropdown(false);
  };

  const saveCurrency = () => {
    const currencyCookie =
      parseCookie(document.cookie)["MkHcCurrencyId"] ?? defaultCurrency;
    setDefaultCurrency(currencyCookie);
    if (order.data.orderLines) {
      disableButtonElements(true);
      savePreferedCurrencyDetails(
        defaultCurrency,
        order.data,
        setOrder,
        loadPage
      );
    }
  };

  const disableButtonElements = (disableFlag: boolean) => {
    const container = document.getElementById("root");
    if (container) {
      const elements = container.querySelectorAll("button");
      elements.forEach((element) => {
        if (element instanceof HTMLButtonElement)
          element.disabled = disableFlag;
      });
    }
  };

  return allowedCurrencies?.length && defaultCurrency ? (
    <div
      id="mkhc-currency-toggle"
      className="tw-flex before:tw-self-center before:tw-content-['|'] before:tw-mx-2 before:tw-text-xl"
    >
      <div
        className="tw-relative"
        onMouseEnter={mouseEnterHandler}
        onMouseLeave={mouseLeaveHandler}
      >
        <BreadCrumbsCurrencyOption
          isOnClickDisabled={true}
          currencyIso={defaultCurrency}
        />
        {showCurrencyDropdown && isAllowCurrencyChange && (
          <div
            className="tw-pt-1 tw-absolute tw-right-0 tw-z-[10001] tw-mr-[-1.5rem]"
            onMouseEnter={mouseEnterHandler}
            onMouseLeave={mouseLeaveHandler}
          >
            {allowedCurrencies.length > 1 && (
              <div className="tw-py-1 tw-px-5 tw-bg-white tw-border tw-rounded-xl tw-shadow-2xl mkhc-language-dropdown">
                {allowedCurrencies
                  .filter((curr) => curr !== defaultCurrency)
                  .map((curr) => (
                    <BreadCrumbsCurrencyOption
                      key={curr}
                      currencyIso={curr}
                      savePreferedCurrencyDetailsCallBack={saveCurrency}
                    />
                  ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  ) : null;
};
